const styles = {
  root: {
    background: '#FDFDFD',
    height: '100vh',
    paddingBottom: 82,
    boxSizing: 'border-box',
    overflow: 'auto',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
    '& .floating-action': {
      position: 'absolute',
      bottom: 0,
      left: 0,
      right: 0,
      paddingBottom: 16,
      paddingTop: 8,
    },
    '& .head': {
      padding: '16px 0',
      background: '#FDFDFD',
    },
    '& .package-box': {
      boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.1), 0px 2px 4px rgba(0, 0, 0, 0.04)',
      borderRadius: 8,
      overflow: 'hidden',
      '& .regular': { height: 8, background: '#004C3B' },
      '& .detail-container': {
        padding: 16,
        background: '#fff',
        borderRadius: 8,
        position: 'relative',
        top: -4,
      },
    },
  },
};

export default styles;
